export enum LogisticsProviders {    
    Sterling = 1,
    LocalOpo = 2,
    AirNet = 3,
    Nora = 4
}